export function getFrequencySelectionLabel(frequency: number): string {
	return `${frequency} week${frequency === 1 ? '' : 's'}`;
}